export default function (nga, admin, activities) {
    var event = admin.getEntity('events');
    event.listView()
        .enable(false)
        .title('{{ "Events" | translate }}')
        .fields([
            nga.field('activity_id', 'reference')
                .targetEntity(activities)
                .targetField(nga.field('name'))
                .label('Activity'),
            nga.field('title'),
            nga.field('start_time'),
            nga.field('end_time')
        ])
        .sortField('start_time').sortDir('ASC')
        .listActions([])
        .batchActions([])
        .actions([]);
    // TDOO: evaluation
    event.creationView()
        .fields([
            // nga.field('group_therapy_id', 'number').editable(false),
            // TODO: Show Group Therapy group and date
            nga.field('group_therapy_id', 'reference')
                .isDetailLink(false)
                .targetEntity(admin.getEntity('group_therapies'))
                .targetField(
                    nga.field('date')
                    .template(
                        '{{entry.values["group.name"]}} - {{entry.values.date | date : "EEEE, d \'de\' MMMM \'de\' yyyy"}}')
                )
                .label('Group Therapy')
                .editable(false),
            // FIXME: add custom validation on the client: either title or activity_id
            nga.field('title')
                // Use title only when there is no activity
                .template('<ma-field ng-if="!entry.values.activity_id" field="::field" value="entry.values[field.name()]" entry="entry" entity="::entity" form="formController.form" datastore="::formController.dataStore"></ma-field>', true),
            nga.field('activity_id', 'reference')
                .targetEntity(activities)
                .targetField(nga.field('name'))
                // .template('<input type="hidden" name="activity_id" ng-value="entry.values.activity_id"/><ma-reference-field field="::field" value="value" datastore="::datastore" class="ng-isolate-scope"></ma-reference-field>')
                .label('Activity')
                .isDetailLink(false),
            nga.field('start_time')
                .validation({ required: true, pattern: /([01]\d|2[0-3]):([0-5]\d)/ })
                .label('Start Time (hh:mm)'),
            nga.field('end_time')
                .validation({ required: true, pattern: /([01]\d|2[0-3]):([0-5]\d)/ })
                .label('End Time (hh:mm)'),
            /*
             * FIXME: this hidden field was introduced to filter by exercises by
             * activity on the `exercise_ids` reference_many field below
             * This is a work around while ng-admin doesn't support the desired
             * functionality.
             * Notice that an interceptor that
             */
            nga.field('activity_id', 'number')
                .template('<ma-field style="display:none;" field="::field" value="entry.values[field.name()]" entry="entry" entity="::entity" form="formController.form" datastore="::formController.dataStore"></ma-field>', true),
            nga.field('exercise_ids', 'reference_many')
              .label('Exercises')
              .template('<ma-field ng-if="entry.values.activity_id" field="::field" value="entry.values[field.name()]" entry="entry" entity="::entity" form="formController.form" datastore="::formController.dataStore"></ma-field>', true)
              .targetEntity(nga.entity('exercises'))
              .targetField(nga.field('title'))
              .attributes({ placeholder: 'Select some exercises...' })
              // FIXME: Look only on exercises of the activity
              // TODO: research a bit and open ticket, see where searchQuery is called and how to access entry values
              .remoteComplete(true, {
                  refreshDelay: 300,
                  searchQuery: function(search) {
                    return {
                        q: search,
                        activity_id: document.querySelector('input[name=activity_id]').value
                    };
                  }
              })
        ])
        .actions([]);



    event.editionView()
        .title('{{ "EDIT" | translate }}')
        // TODO: activity_id field not editable
        .fields(event.creationView().fields())
        .actions(['delete']);

    return event;
}



// WEBPACK FOOTER //
// ./js/events/config.js